import { element, showMessage } from './publicUi.js';
import { getLocale } from '../services/i18n.js';

const roles = [['RESEARCHER', 'Исследователь'], ['SENIOR_RESEARCHER', 'Старший исследователь']];
const day = 86400000;

function localDateTime(date) {
  const pad = value => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function inviteStateText(invite, now = Date.now()) {
  if (invite.revokedAt) return 'Отозван';
  if (new Date(invite.expiresAt).getTime() <= now) return 'Истёк';
  if (invite.uses >= invite.maxUses) return 'Исчерпан';
  return 'Активен';
}

export class InviteEditor {
  constructor({ item, create, revoke, saved, denied, cancel, checkList }) {
    Object.assign(this, { item, create, revoke, saved, denied, cancel, checkList });
  }
  render() {
    this.form = element('form', 'spec-box post-editor');
    if (this.item) this.renderRevoke(); else this.renderCreate();
    return this.form;
  }
  renderCreate() {
    this.form.append(element('h2', 'spec-title', 'Новый инвайт'));
    this.role = element('select', 'auth-input'); this.role.name = 'role'; this.role.setAttribute('aria-label', 'Роль по инвайту');
    for (const [value, label] of roles) { const option = element('option', '', label); option.value = value; this.role.append(option); }
    this.role.options[0]?.setAttribute('selected', '');
    const roleLabel = element('label', 'auth-form-label', 'Роль нового пользователя'); roleLabel.append(this.role);
    const now = new Date(), latest = new Date(now.getTime() + 365 * day);
    this.expiresAt = element('input', 'auth-input'); this.expiresAt.type = 'datetime-local'; this.expiresAt.name = 'expiresAt'; this.expiresAt.required = true;
    this.expiresAt.min = localDateTime(now); this.expiresAt.max = localDateTime(latest); this.expiresAt.value = localDateTime(new Date(now.getTime() + 7 * day));
    const expiryLabel = element('label', 'auth-form-label', 'Срок действия (не более года)'); expiryLabel.append(this.expiresAt);
    this.maxUses = element('input', 'auth-input'); this.maxUses.type = 'number'; this.maxUses.name = 'maxUses'; this.maxUses.min = '1'; this.maxUses.max = '1000'; this.maxUses.step = '1'; this.maxUses.value = '1'; this.maxUses.required = true;
    const usesLabel = element('label', 'auth-form-label', 'Максимальное число регистраций'); usesLabel.append(this.maxUses);
    this.submitButton = element('button', 'filter-btn', 'Создать инвайт');
    this.cancelButton = element('button', 'filter-btn', 'Закрыть форму'); this.cancelButton.type = 'button';
    this.cancelButton.addEventListener('click', () => { if (!this.busy && !this.disposed) this.cancel(); });
    this.feedback = element('div'); this.feedback.setAttribute('role', 'status');
    this.checkListButton = element('button', 'filter-btn', 'Проверить список без повторного создания'); this.checkListButton.type = 'button'; this.checkListButton.hidden = true;
    this.checkListButton.addEventListener('click', () => { if (!this.busy && !this.disposed) void this.checkList?.(); });
    this.secretBox = element('div', 'public-message'); this.secretBox.hidden = true;
    this.secretBox.append(element('p', '', 'Сохраните код сейчас. После закрытия формы он больше не будет показан.'));
    this.secretNode = element('code'); this.secretNode.style.display = 'block'; this.secretNode.style.overflowWrap = 'anywhere'; this.secretBox.append(this.secretNode);
    this.form.append(roleLabel, expiryLabel, usesLabel, this.submitButton, this.cancelButton, this.feedback, this.checkListButton, this.secretBox);
    this.form.addEventListener('submit', event => { event.preventDefault(); void this.submit(); });
  }
  renderRevoke() {
    this.form.append(element('h2', 'spec-title', 'Отзыв инвайта'),
      element('p', 'profile-text', `${roles.find(([value]) => value === this.item.role)?.[1] ?? this.item.role} · использовано ${this.item.uses} из ${this.item.maxUses}`),
      element('p', 'profile-text', `Срок: ${new Date(this.item.expiresAt).toLocaleString(getLocale())} · ${inviteStateText(this.item)}`));
    this.feedback = element('div'); this.feedback.setAttribute('role', 'status');
    this.revokeButton = element('button', 'filter-btn admin-delete-button', 'Отозвать инвайт'); this.revokeButton.type = 'button';
    this.cancelButton = element('button', 'filter-btn', 'Вернуться к списку'); this.cancelButton.type = 'button';
    this.cancelButton.addEventListener('click', () => { if (!this.busy && !this.disposed) this.cancel(); });
    this.checkListButton = element('button', 'filter-btn', 'Вернуться к списку и проверить результат'); this.checkListButton.type = 'button'; this.checkListButton.hidden = true;
    this.checkListButton.addEventListener('click', () => { if (!this.busy && !this.disposed) void this.checkList?.(); });
    this.confirmation = element('div', 'public-message'); this.confirmation.hidden = true;
    this.confirmation.append(element('p', '', `Отозвать инвайт ${this.item.id}? Регистрация с ним станет недоступна.`));
    this.confirmButton = element('button', 'filter-btn admin-delete-button', 'Да, отозвать инвайт'); this.confirmButton.type = 'button';
    this.backButton = element('button', 'filter-btn', 'Оставить инвайт'); this.backButton.type = 'button';
    this.revokeButton.addEventListener('click', () => { if (!this.busy && !this.disposed && !this.uncertain) { this.confirmation.hidden = false; this.backButton.focus(); } });
    this.backButton.addEventListener('click', () => { if (!this.busy) { this.confirmation.hidden = true; this.revokeButton.focus(); } });
    this.confirmButton.addEventListener('click', () => { void this.revokeInvite(); });
    this.confirmation.append(this.confirmButton, this.backButton);
    this.form.append(this.revokeButton, this.cancelButton, this.feedback, this.checkListButton, this.confirmation);
  }
  setBusy(value) {
    this.busy = value;
    for (const control of this.form.querySelectorAll('input,select,button')) {
      control.disabled = value || (!!this.completed && control !== this.cancelButton)
        || (!!this.uncertain && control !== this.cancelButton && control !== this.checkListButton);
    }
  }
  async submit() {
    if (this.item || this.busy || this.disposed || this.completed || this.uncertain) return;
    const expiry = new Date(this.expiresAt.value), maxUses = Number(this.maxUses.value), now = Date.now();
    if (!roles.some(([value]) => value === this.role.value) || !Number.isInteger(maxUses) || maxUses < 1 || maxUses > 1000
      || !Number.isFinite(expiry.getTime()) || expiry.getTime() <= now || expiry.getTime() > now + 365 * day) {
      showMessage(this.feedback, 'Выберите допустимую роль, будущий срок не более года и число регистраций от 1 до 1000.'); return;
    }
    this.setBusy(true); showMessage(this.feedback, 'Создание инвайта…');
    try {
      const result = await this.create({ role: this.role.value, expiresAt: expiry.toISOString(), maxUses });
      if (!/^[a-f0-9]{64}$/i.test(result?.code ?? '')) throw new Error('Invalid invite response');
      if (this.disposed) return;
      this.secret = result.code; this.secretNode.textContent = this.secret; this.secretBox.hidden = false; this.completed = true;
      showMessage(this.feedback, 'Инвайт создан. Код показан только в этой форме.'); void this.saved?.(result);
    } catch (error) { this.handleFailure(error, 'создания инвайта'); }
    finally { this.busy = false; if (!this.disposed) this.setBusy(false); }
  }
  async revokeInvite() {
    if (!this.item || this.busy || this.disposed || this.completed || this.uncertain || this.confirmation.hidden) return;
    this.setBusy(true); showMessage(this.feedback, 'Отзыв инвайта…');
    try {
      await this.revoke(this.item.id); this.completed = true;
      if (!this.disposed) { showMessage(this.feedback, 'Инвайт отозван.'); this.saved(); }
    } catch (error) {
      if (!this.disposed && error.status === 404) { this.completed = true; showMessage(this.feedback, 'Инвайт уже отсутствует.'); this.saved(); }
      else this.handleFailure(error, 'отзыва инвайта');
    } finally { this.busy = false; if (!this.disposed) { this.confirmation.hidden = true; this.setBusy(false); } }
  }
  handleFailure(error, operation) {
    if (this.disposed) return;
    if (error.status === 401 || (error.status === 403 && error.code !== 'CSRF_INVALID')) { this.denied(error); return; }
    this.uncertain = !error.status || error.status >= 500 || error.code === 'UNAVAILABLE';
    this.checkListButton.hidden = !this.uncertain || !this.checkList;
    showMessage(this.feedback, this.uncertain
      ? `Результат ${operation} неизвестен. Не повторяйте операцию; проверьте список.`
      : error.message);
  }
  dispose() {
    this.disposed = true; this.secret = null;
    if (this.secretNode) this.secretNode.textContent = '';
  }
}
